(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/betslip-error-message.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/betslip-error-message.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.BetslipErrorMessage = Backbone.Marionette.View.extend({
    modelEvents: {
      change: 'render'
    },

    template: function(data) {
      return svs.tipset.templates.betsliperrormessage(data);
    },

    onDomRefresh: function() {
      svs.tipset.views.betslip.doResize();
    }
  });
})(Backbone, _, svs);

 })(window);